import React from "react";
import { Typography } from "@material-tailwind/react";
import { ReactComponent as InterviewAILogo } from "../../assets/icons/InterviewAILogo.svg";
import DashboardTopHeader from "../DashboardPage/DashboardTopHeader";

const AdminHeader = () => {
  return (
    <div className="shrink-0 z-50 flex items-center bg-white shadow-md">
      <div className="flex items-center space-x-4 w-64 px-6 py-4">
        <InterviewAILogo className="h-10 w-10" />
        <div>
          <Typography variant="h6" className="text-xl font-bold text-black">
            InterviewAI
          </Typography>
          <p className="text-sm text-black">Admin Dashboard</p>
        </div>
      </div>
      <DashboardTopHeader/>
    </div>
  );
};

export default AdminHeader;
